
import React, { useCallback, useEffect, useState } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import * as XLSX from 'xlsx';
import {
  Row, Col, Card, Table, Button, Input, AutoComplete,
  notification, Modal, Select, Avatar, Typography, TableColumnsType,
  Checkbox, DatePicker, Drawer, Form, InputNumber, Tooltip, TimePicker,
  Space, Tag, Spin, Badge
} from "antd";

import axios from "axios";
import { baseUrl } from "../../config";
import {
  DeleteOutlined, FileExcelOutlined, CalendarOutlined, SendOutlined,
  FilterOutlined, EditOutlined, ExclamationCircleOutlined, SearchOutlined,
  EyeOutlined, UserOutlined, PlusOutlined, ReloadOutlined, CloseOutlined,
  PhoneOutlined, EnvironmentOutlined, ClockCircleOutlined, TeamOutlined,
  BankOutlined, MessageOutlined
} from "@ant-design/icons";
import userDummy from "../../assets/images/dummy-user.png";
import { getPermissions, hasPermission } from '../../components/permissions';
import '../../assets/styles/custom_style.css';
import moment from 'moment';
import ImportListModal from './components/importListModal';
import VisitorForm from './Form';

const { confirm } = Modal;
const { Search } = Input;
const { Option } = Select;
const { Title, Text } = Typography;
const { Item } = Form;
const { TextArea } = Input;

function VisitorManagement() {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPageQuery = parseInt(queryParams.get('page')) || 1;
  const limitQuery = parseInt(queryParams.get('limit')) || 20;

  const [visitorList, setVisitorList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(limitQuery);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    name: queryParams.get('name') || '',
    phone_no: queryParams.get('phone_no') || '',
    visit_branch: queryParams.get('visit_branch') || '',
    purpose_visit: queryParams.get('purpose_visit') || '',
    visit_date: queryParams.get('visit_date') || '',
    createdAt: queryParams.get('createdAt') || '',
  });

  // Drawer states
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [currentVisitorId, setCurrentVisitorId] = useState(null);
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  // Filter states
  const [showVisitorFilter, setShowVisitorFilter] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [isModalVisibleImportList, setIsModalVisibleImportList] = useState(false);

  // Branch options
  const branchOptions = [
    "अखिल भारतीय राजपुरोहित समाज विकास संस्थान",
    "श्री खेतेश्वर गुरुकुल, मायलावास",
    "श्री खेतेश्वर गुरुकुल, बिजरोल खेड़ा",
    "श्री खेतेश्वर गुरुकुल, सायला",
    "श्री खेतेश्वर गुरुकुल, सवाई छोटी",
    "श्री खेतेश्वर भवन, हरिद्वार"
  ];

  // Enhanced table columns with better styling
  const columns = [
    {
      title: <Text strong style={{ color: '#7a0000' }}>#</Text>,
      dataIndex: "key",
      key: "key",
      fixed: 'left',
      width: 60,
      align: 'center',
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Phone Number</Text>,
      dataIndex: "phone_no",
      key: "phone_no",
      fixed: 'left',
      width: 140,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Visitor Name</Text>,
      dataIndex: "name",
      key: "name",
      width: 150,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Visit Branch</Text>,
      dataIndex: 'visit_branch',
      key: 'visit_branch',
      width: 200,
      ellipsis: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Purpose</Text>,
      dataIndex: "purpose_visit",
      key: "purpose_visit",
      width: 150,
      ellipsis: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Visit Date</Text>,
      dataIndex: "visit_date",
      key: "visit_date",
      width: 130,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Time In</Text>,
      dataIndex: "visit_time_in",
      key: "visit_time_in",
      width: 100,
      align: 'center',
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Time Out</Text>,
      dataIndex: "visit_time_out",
      key: "visit_time_out",
      width: 100,
      align: 'center',
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Remark</Text>,
      dataIndex: "remark",
      key: "remark",
      width: 150,
      ellipsis: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Message Status</Text>,
      dataIndex: "message_status",
      key: "message_status",
      width: 130,
      align: 'center',
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Last Sent</Text>,
      key: "last_date",
      dataIndex: "last_date",
      width: 130,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Actions</Text>,
      key: "action",
      dataIndex: "action",
      fixed: 'right',
      width: 150,
      align: 'center',
    }
  ];

  useEffect(() => {
    const { state } = history.location;
    const restoredPage = state?.page || currentPage;
    const restoredLimit = state?.limit || limit;
    getVisitorList(restoredPage, restoredLimit, sortField, sortOrder, search, filters);
  }, [history.location]);

  // Drawer functions
  const showDrawer = (visitorId = null) => {
    setCurrentVisitorId(visitorId);
    setIsUpdateMode(!!visitorId);
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
    setCurrentVisitorId(null);
    setIsUpdateMode(false);
  };

  const onRefresh = () => {
    closeDrawer();
    getVisitorList(currentPage, limit, sortField, sortOrder, search, filters);
  };

  async function getVisitorList(page = 1, limit = 20, sortField = null, sortOrder = null, search = '', filters = {}) {
    try {
      setLoading(true);
      setCurrentPage(page);
      setLimit(limit);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/visitor/list?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setVisitorList(response.data.result);
        setPagination({
          current: page,
          pageSize: limit,
          total: response.data.totalCount
        });
      } else {
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.error({
        message: 'Error',
        description: 'Failed to fetch visitor data',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  }

  async function handleDelete(id) {
    try {
      const response = await axios.delete(`${baseUrl}/visitor/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        getVisitorList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
        notification.success({
          message: 'Success',
          description: 'Visitor record deleted successfully!',
          placement: 'topRight'
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.error({
        message: 'Error',
        description: 'Failed to delete visitor record',
        placement: 'topRight'
      });
    }
  }

  const showDeleteConfirm = (id, visitorInfo) => {
    confirm({
      title: 'Delete Visitor Record',
      icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
      content: (
        <div>
          <p>Are you sure you want to delete this visitor record?</p>
          {visitorInfo && (
            <div style={{ 
              background: '#fff2f0', 
              border: '1px solid #ffccc7', 
              padding: '8px 12px', 
              borderRadius: '6px',
              marginTop: '8px'
            }}>
              <Text strong style={{ color: '#cf1322' }}>Visitor to be deleted:</Text>
              <br />
              <Text>{visitorInfo.name} - {visitorInfo.phone_no}</Text>
              <br />
              <Text type="secondary">{visitorInfo.visit_branch}</Text>
            </div>
          )}
          <p style={{ color: '#8c8c8c', fontSize: '12px', marginTop: '8px' }}>
            ⚠️ This action cannot be undone.
          </p>
        </div>
      ),
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      okButtonProps: {
        danger: true,
        style: { borderRadius: '6px' }
      },
      cancelButtonProps: {
        style: { borderRadius: '6px' }
      },
      onOk() {
        handleDelete(id);
      },
    });
  };

  const handleResendMessage = async (visitorId, visitorName) => {
    Modal.confirm({
      title: 'Send/Resend Message',
      content: (
        <div>
          <p>Are you sure you want to send a message to <strong>{visitorName}</strong>?</p>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            This will send a notification message about their visit.
          </Text>
        </div>
      ),
      okText: 'Send Message',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          setLoading(true);
          const response = await axios.patch(`${baseUrl}/visitor/messageresend/${visitorId}`, 
            { send: 'yes' }, 
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              },
            }
          );

          if (response.status === 200) {
            getVisitorList(currentPage, limit, sortField, sortOrder, search, filters);
            notification.success({
              message: 'Success',
              description: 'Message sent successfully!',
              placement: 'topRight',
            });
          }
        } catch (error) {
          notification.error({
            message: 'Error',
            description: 'Failed to send message',
            placement: 'topRight'
          });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    const { field, order } = sorter;
    const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
    setSortField(field);
    setSortOrder(formattedOrder);
    setFilters(filters);
    history.push(`?page=${current}&limit=${pageSize}`);
    getVisitorList(current, pageSize, field, formattedOrder, search, filters);
  };

  const handleLimitChange = value => {
    setLimit(value);
    const updatedQueryParams = new URLSearchParams(location.search);
    updatedQueryParams.set('limit', value);
    updatedQueryParams.set('page', 1);
    history.push(`?${updatedQueryParams.toString()}`);
    getVisitorList(1, value);
  };

  const handleFilterChange = (field, value) => {
    const newFilters = {
      ...filters,
      [field]: value
    };
    setFilters(newFilters);
    const updatedQueryParams = new URLSearchParams(location.search);
    Object.keys(newFilters).forEach(key => {
      if (newFilters[key]) {
        updatedQueryParams.set(key, newFilters[key]);
      } else {
        updatedQueryParams.delete(key);
      }
    });
    history.push(`?${updatedQueryParams.toString()}`);
  };

  const handleSearch = () => {
    getVisitorList(1, limit, sortField, sortOrder, search, filters);
  };

  const handleResetFilters = () => {
    const resetFilters = {
      name: '',
      phone_no: '',
      visit_branch: '',
      purpose_visit: '',
      visit_date: '',
      createdAt: '',
    };
    setFilters(resetFilters);
    setSearch('');
    const updatedQueryParams = new URLSearchParams(location.search);
    Object.keys(resetFilters).forEach(key => {
      updatedQueryParams.delete(key);
    });
    history.push(`?${updatedQueryParams.toString()}`);
    getVisitorList(1, limit, sortField, sortOrder, '', resetFilters);
  };

  const exportToExcel = async () => {
    try {
      setLoading(true);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/visitor/list?page=${1}&limit=all${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        const formattedData = response.data.result.map((visitor, index) => ({
          "Sr.No": index + 1,
          "Phone Number": visitor.phone_no || '-',
          "Visitor Name": visitor.name || '-',
          "Visit Branch": visitor.visit_branch || '-',
          "Purpose": visitor.purpose_visit || '-',
          "Visit Date": visitor.visit_date ? moment(visitor.visit_date).format('DD-MM-YYYY') : '-',
          "Time In": visitor.visit_time_in || '-',
          "Time Out": visitor.visit_time_out || '-',
          "Remark": visitor.remark || '-',
          "Message Sent": visitor.is_send === 1 ? 'Yes' : 'No',
          "Last Message Date": visitor.last_date ? moment(visitor.last_date).format('DD-MM-YYYY') : '-',
          "Created Date": visitor.createdAt ? moment(visitor.createdAt).format('DD-MM-YYYY') : '-',
        }));

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Visitor-List");
        XLSX.writeFile(workbook, "Visitor-Management-List.xlsx");
        
        notification.success({
          message: 'Success',
          description: 'Visitor list exported successfully!',
          placement: 'topRight'
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to export data',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };

  const isPhoneMatched = (visitor) => {
    return visitor.phone_no === visitor.user_phone_no;
  };

  const formatTime = (timeString) => {
    if (!timeString || timeString === "00:00:00") return "-";
    return moment(timeString, "HH:mm:ss").format("h:mm A");
  };

  const getBranchShortName = (branchName) => {
    if (!branchName) return '-';
    const mapping = {
      "अखिल भारतीय राजपुरोहित समाज विकास संस्थान": "ABRSVS",
      "श्री खेतेश्वर गुरुकुल, मायलावास": "मायलावास",
      "श्री खेतेश्वर गुरुकुल, बिजरोल खेड़ा": "बिजरोल खेड़ा",
      "श्री खेतेश्वर गुरुकुल, सायला": "सायला",
      "श्री खेतेश्वर गुरुकुल, सवाई छोटी": "सवाई छोटी",
      "श्री खेतेश्वर भवन, हरिद्वार": "हरिद्वार"
    };
    return mapping[branchName] || branchName;
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            headStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}
            title={
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <TeamOutlined style={{ color: '#fff', fontSize: '20px' }} />
                <Title level={3} style={{ margin: 0, color: '#fff' }}>
                  Visitor Management System
                </Title>
              </div>
            }
            extra={
              <Space size="middle">
                <Button
                  type="default"
                  icon={<FileExcelOutlined />}
                  onClick={() => setIsModalVisibleImportList(true)}
                  style={{ borderRadius: '6px' }}
                >
                  Import List
                </Button>
                {hasPermission('/visitor', 'createPermission') && (
                  <Button
                    onClick={() => showDrawer()}
                    style={{
                      background: '#fff',
                      color: '#7a0000',
                      borderColor: '#fff',
                      borderRadius: '6px',
                      fontWeight: 600,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.15)'
                    }}
                  >
                    Add New Visitor
                  </Button>
                )}
                <Button
                  type="default"
                  icon={<FileExcelOutlined />}
                  onClick={exportToExcel}
                  loading={loading}
                  style={{ borderRadius: '6px' }}
                >
                  Export Excel
                </Button>
              </Space>
            }
          >
            <div className="table-responsive">
              <Table
                columns={columns}
                loading={loading}
                scroll={{ x: 'max-content' }}
                bordered
                size="middle"
                title={() => (
                  <div style={{ marginBottom: '16px' }}>
                    <Row gutter={[16, 16]} align="middle">
                      <Col>
                        <Button
                          icon={<FilterOutlined />}
                          onClick={() => setShowVisitorFilter(!showVisitorFilter)}
                          style={{
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}
                        >
                          {showVisitorFilter ? 'Hide Filters' : 'Show Filters'}
                        </Button>
                      </Col>
                    </Row>

                    {/* Filters */}
                    {showVisitorFilter && (
                      <div style={{
                        marginTop: '16px',
                        padding: '16px',
                        background: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef'
                      }}>
                        <Title level={5} style={{ marginBottom: '16px', color: '#7a0000' }}>
                          🔍 Filter Visitors
                        </Title>
                        <Row gutter={[12, 12]}>
                          <Col span={6}>
                            <Input
                              placeholder="Phone Number"
                              value={filters.phone_no}
                              onChange={e => handleFilterChange('phone_no', e.target.value)}
                              style={{ borderRadius: '6px' }}
                              prefix={<PhoneOutlined />}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Visitor Name"
                              value={filters.name}
                              onChange={e => handleFilterChange('name', e.target.value)}
                              style={{ borderRadius: '6px' }}
                              prefix={<UserOutlined />}
                            />
                          </Col>
                          <Col span={6}>
                            <Select
                              style={{ width: '100%' }}
                              placeholder="Select Branch"
                              value={filters.visit_branch}
                              onChange={value => handleFilterChange('visit_branch', value)}
                              allowClear
                            >
                              {branchOptions.map((branch) => (
                                <Option key={branch} value={branch}>
                                  {getBranchShortName(branch)}
                                </Option>
                              ))}
                            </Select>
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Purpose of Visit"
                              value={filters.purpose_visit}
                              onChange={e => handleFilterChange('purpose_visit', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <DatePicker
                              format="DD-MM-YYYY"
                              value={filters.visit_date ? moment(filters.visit_date, 'DD-MM-YYYY') : null}
                              onChange={(date, dateString) => handleFilterChange('visit_date', dateString)}
                              placeholder="Visit Date"
                              style={{ width: '100%', borderRadius: '6px' }}
                            />
                          </Col>

                          <Col span={24}>
                            <Space>
                              <Button
                                icon={<SearchOutlined />}
                                onClick={handleSearch}
                                style={{ borderRadius: '6px', background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}
                              >
                                Search
                              </Button>
                              <Button
                                icon={<ReloadOutlined />}
                                onClick={handleResetFilters}
                                style={{ borderRadius: '6px' }}
                              >
                                Reset All Filters
                              </Button>
                            </Space>
                          </Col>
                        </Row>
                      </div>
                    )}

                    <Row style={{ marginTop: '16px' }}>
                      <Col>
                        <Space align="center">
                          <Text strong>Records per page:</Text>
                          <Select
                            value={limit}
                            onChange={handleLimitChange}
                            style={{ width: 80, borderRadius: '6px' }}
                          >
                            <Option value={20}>20</Option>
                            <Option value={40}>40</Option>
                            <Option value={60}>60</Option>
                            <Option value={80}>80</Option>
                            <Option value={100}>100</Option>
                          </Select>
                        </Space>
                      </Col>
                    </Row>
                  </div>
                )}
                dataSource={visitorList.map((visitor, index) => {
                  const phoneMatched = isPhoneMatched(visitor);
                  
                  return {
                    key: (limit * (currentPage - 1)) + index + 1,
                    phone_no: (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <PhoneOutlined style={{ color: '#7a0000' }} />
                        <Tag
                          color={phoneMatched ? 'success' : 'default'}
                          style={{
                            borderRadius: '12px',
                            padding: '4px 12px',
                            fontWeight: '500'
                          }}
                        >
                          {visitor.phone_no}
                        </Tag>
                        {phoneMatched && (
                          <Tooltip title="Number matches with registered member">
                            <Badge status="success" />
                          </Tooltip>
                        )}
                      </div>
                    ),
                    name: (
                      <Text strong style={{ color: '#262626' }}>{visitor.name || '-'}</Text>
                    ),
                    visit_branch: (
                      <Tooltip title={visitor.visit_branch} placement="topLeft">
                        <Tag color="blue" style={{ borderRadius: '12px', maxWidth: '150px' }}>
                          <BankOutlined style={{ marginRight: '4px' }} />
                          {getBranchShortName(visitor.visit_branch)}
                        </Tag>
                      </Tooltip>
                    ),
                    purpose_visit: (
                      <Tooltip title={visitor.purpose_visit} placement="topLeft">
                        <Text style={{ color: '#595959' }}>
                          {visitor.purpose_visit ? (visitor.purpose_visit.length > 20 ? `${visitor.purpose_visit.substring(0, 20)}...` : visitor.purpose_visit) : '-'}
                        </Text>
                      </Tooltip>
                    ),
                    visit_date: (
                      <Text>
                        {visitor.visit_date && visitor.visit_date !== "0000-00-00" 
                          ? moment(visitor.visit_date).format('DD MMM YYYY') 
                          : '-'}
                      </Text>
                    ),
                    visit_time_in: (
                      <Tag color="green" style={{ borderRadius: '8px' }}>
                        <ClockCircleOutlined style={{ marginRight: '4px' }} />
                        {formatTime(visitor.visit_time_in)}
                      </Tag>
                    ),
                    visit_time_out: (
                      <Tag color="orange" style={{ borderRadius: '8px' }}>
                        <ClockCircleOutlined style={{ marginRight: '4px' }} />
                        {formatTime(visitor.visit_time_out)}
                      </Tag>
                    ),
                    remark: (
                      <Tooltip title={visitor.remark} placement="topLeft">
                        <Text style={{ color: '#595959' }}>
                          {visitor.remark ? (visitor.remark.length > 20 ? `${visitor.remark.substring(0, 20)}...` : visitor.remark) : '-'}
                        </Text>
                      </Tooltip>
                    ),
                    message_status: (
                      <Badge 
                        status={visitor.is_send === 1 ? 'success' : 'default'} 
                        text={
                          <Text style={{ fontSize: '12px', fontWeight: '500' }}>
                            {visitor.is_send === 1 ? 'Sent' : 'Not Sent'}
                          </Text>
                        }
                      />
                    ),
                    last_date: (
                      <Text>
                        {visitor.last_date && visitor.last_date !== '0000-00-00' 
                          ? moment(visitor.last_date).format('DD MMM YYYY') 
                          : '-'}
                      </Text>
                    ),
                    action: (
                      <Space size="small">
                        {hasPermission('/visitor', 'editPermission') && (
                          <Button
                            size="small"
                            icon={<EditOutlined />}
                            onClick={() => showDrawer(visitor.id)}
                            style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff', borderRadius: '4px' }}
                          >Edit</Button>
                        )}
                        {hasPermission('/visitor', 'deletePermission') && (
                          <Button
                            danger
                            size="small"
                            icon={<DeleteOutlined />}
                            onClick={() => showDeleteConfirm(visitor.id, {
                              name: visitor.name,
                              phone_no: visitor.phone_no,
                              visit_branch: visitor.visit_branch
                            })}
                          >Delete</Button>
                        )}
                        {hasPermission('/visitor', 'editPermission') && (
                          <Button
                            size="small"
                            icon={<MessageOutlined />}
                            onClick={() => handleResendMessage(visitor.id, visitor.name)}
                          >Message</Button>
                        )}
                      </Space>
                    )
                  };
                })}
                pagination={{
                  ...pagination,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} records`,
                  showSizeChanger: false,
                  style: { marginTop: '16px' }
                }}
                onChange={handleTableChange}
                className="ant-border-space"
                style={{
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}
              />
            </div>
          </Card>
        </Col>
      </Row>

      {/* Enhanced Drawer for Add/Edit */}
      <Drawer
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {isUpdateMode ? <EditOutlined style={{ color: 'white', fontSize: '18px' }} /> : <TeamOutlined style={{ color: 'white', fontSize: '18px' }} />}
            </div>
            <div>
              <Title level={4} style={{ margin: 0, color: 'white' }}>
                {isUpdateMode ? 'Update Visitor' : 'Add Visitor'}
              </Title>
              
            </div>
          </div>
        }
        width={window.innerWidth > 768 ? 560 : '95%'}
        open={drawerVisible}
        onClose={closeDrawer}
        closable={false}
        bodyStyle={{
          padding: 0,
          background: '#f8f9fa'
        }}
        headerStyle={{
          background: '#7a0000',
          border: 'none'
        }}
        extra={
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={closeDrawer}
            style={{ color: 'white' }}
          />
        }
        destroyOnClose
      >
        <div style={{ height: '100%', padding: '24px' }}>
          <VisitorForm 
            userId={currentVisitorId} 
            onRefreshData={onRefresh}
          />
        </div>
      </Drawer>

      {/* Import Modal */}
      <ImportListModal
        isVisible={isModalVisibleImportList}
        onClose={() => setIsModalVisibleImportList(false)}
        onSuccess={() => {
          setIsModalVisibleImportList(false);
          getVisitorList();
        }}
      />

      {/* Image Modal */}
      <Modal
        open={isModalVisible}
        footer={null}
        onCancel={() => setIsModalVisible(false)}
        centered
      >
        <img
          src={currentImage}
          alt="Visitor Document"
          style={{ width: '100%', borderRadius: '8px' }}
        />
      </Modal>
    </div>
  );
}

export default VisitorManagement;